/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Login.scss';
import Aux from 'hoc/ReactAux/ReactAux';
import imgLogo from 'images/logo-3.png';
import imgClose from 'images/close.svg';
import TextInput from 'components/UI/TextInput';
import * as actions from 'actions/index';

const PasswordForm = props => {
  return (
    <form aria-label="login">
      <TextInput
        id={`password${props.target || ''}`}
        name="password"
        type="password"
        placeholder="Password"
        aria_description="Enter the password of your Lunch Team Account"
        autoFocus={true}
        onChange={props.updateField}
        value={props.password}
      />
      <input
        onClick={props.handleClickLogin}
        className="bt"
        type="submit"
        value="Login"
      />
      <div className="forgot">
        <a target="_blank" onClick={props.handleForgotPassword}>
          Forgot your Password?
        </a>
      </div>
      <div className="checkbox-remember">
        <label className="container">
          Stay Signed In
          <input
            name="staySigned"
            type="checkbox"
            onChange={props.updateField}
            checked={props.staySigned}
          />
          <span className="checkmark" />
        </label>
      </div>
    </form>
  );
};

export class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      staySigned: false,
      menuMobileActive: false,
      toggleFormLogin: false,
      isMobile: window.innerWidth < 768,
    };

    this.changeMenuClass = this.changeMenuClass.bind(this);
    this.changeLoginClass = this.changeLoginClass.bind(this);
    this.updateField = this.updateField.bind(this);
    this.handleClickLogin = this.handleClickLogin.bind(this);
  }

  changeMenuClass() {
    this.setState({
      menuMobileActive: !this.state.menuMobileActive,
    });
  }

  changeLoginClass() {
    this.setState({
      loginMobileActive: !this.state.loginMobileActive,
    });
  }

  componentDidMount() {
    if (!!this.props.needToTryAutomaticLogin) {
      this.props.tryAutomaticallyLogin();
    }
  }

  componentDidUpdate(previusProps) {
    if (previusProps.preLogin !== this.props.preLogin && this.state.isMobile) {
      this.setState({
        menuMobileActive: this.props.preLogin,
      });
    }
  }

  updateField({ target }) {
    this.setState({
      [target.name]: target.type === 'checkbox' ? target.checked : target.value,
    });
  }

  handleVerifyEmail = event => {
    event.preventDefault();
    if (!!this.state.email) {
      this.props.onRequestVerifyEmail({ email: this.state.email.trim() });
    }
  };

  handleClickLogin = event => {
    event.preventDefault();
    const credentials = {
      email: this.props.email.trim(),
      password: this.state.password,
      staySigned: this.state.staySigned,
    };
    this.props.onRequestLogin(credentials);
  };

  handleForgotPassword = () => {
    this.props.onRequestEmailResetPassword(this.props.email);
  };

  renderEmailForm(target) {
    const { email } = this.state;

    return (
      <form>
        <TextInput
          id={'email' + (target || '')}
          name="email"
          type="text"
          placeholder="Enter Email Address"
          aria_description="Enter your email address of Lunch Team Account"
          onChange={this.updateField}
          value={email}
        />
        <input
          onClick={this.handleVerifyEmail}
          className="bt"
          type="submit"
          value="Next"
          role="button"
        />
      </form>
    );
  }

  render() {
    return (
      <Aux>
        <header className="header" tabIndex={1} aria-label="Lunch Team Header">
          <div className="wrap">
            <a className="logo left" href="./">
              <img alt="Lunch Team Logo" src={imgLogo} />
            </a>
            <a
              className={
                this.state.menuMobileActive
                  ? 'menu-bt-mobile right open'
                  : 'menu-bt-mobile right'
              }
              onClick={this.changeMenuClass}
            >
              <svg
                className="svg-inline--fa fa-bars fa-w-14"
                aria-hidden="true"
                data-prefix="fas"
                data-icon="bars"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                ></path>
              </svg>
            </a>
            <nav className="menu left" role="navigation" tabIndex={2}>
              <ul className="lista-menu">
                <li>
                  <a onClick={this.props.handleHowItWorks}>How It Works</a>
                </li>
                <li>
                  <a onClick={this.props.handleWhatWeDo}>What We Do</a>
                </li>
                <li>
                  <a onClick={this.props.handleOurClients}>
                    Some Of Our Clients
                  </a>
                </li>
                <li>
                  <a onClick={this.props.handleWhyUseUs}>Benefits</a>
                </li>
                <li>
                  <a
                    onClick={() =>
                      window.open('https://forms.gle/tP6qdYZrb8K8fh7i7')
                    }
                  >
                    Become a Driver today!
                  </a>
                </li>
              </ul>
            </nav>
            <div
              aria-label="Login area"
              tabIndex={3}
              className={'login right login-flex'}
            >
              <h4>Create an Account or Login</h4>
              {!!this.props.preLogin ? (
                <PasswordForm
                  handleClickLogin={this.handleClickLogin}
                  handleForgotPassword={this.handleForgotPassword}
                  password={this.state.password}
                  staySigned={this.state.staySigned}
                  updateField={this.updateField}
                />
              ) : (
                this.renderEmailForm()
              )}
            </div>
          </div>
        </header>
        {this.state.isMobile && (
          <div
            className={
              this.state.menuMobileActive
                ? 'menu-mobile-drop open'
                : 'menu-mobile-drop'
            }
            role="button"
            tabIndex={2}
          >
            <a
              role="button"
              aria-label="Mobile navigation menu"
              className="close-drop"
              onClick={this.changeMenuClass}
            >
              <img alt="close button" src={imgClose} />
            </a>
            <div className={this.props.preLogin ? 'login password' : 'login'}>
              <h4>Create An Account or Login</h4>
              <div className="formularios">
                {!this.props.preLogin ? (
                  <div className="form-email">
                    {this.renderEmailForm('-mobile')}
                  </div>
                ) : (
                  <div className="form-password">
                    <PasswordForm
                      handleClickLogin={this.handleClickLogin}
                      handleForgotPassword={this.handleForgotPassword}
                      password={this.state.password}
                      staySigned={this.state.staySigned}
                      updateField={this.updateField}
                      target="-mobile"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Aux>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onRequestVerifyEmail: credentials =>
      dispatch(actions.requestVerifyEmail(credentials)),
    onRequestEmailResetPassword: email =>
      dispatch(actions.requestEmailResetPassword(email)),
    onRequestLogin: credentials => dispatch(actions.requestLogin(credentials)),
    tryAutomaticallyLogin: credentials =>
      dispatch(actions.tryAutomaticallyLogin(credentials)),
  };
};

const mapStateToProps = state => {
  return {
    email: state.signupReducer.email,
    needToTryAutomaticLogin: state.signupReducer.needToTryAutomaticLogin,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/Landing/Header/index.js